import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Outlet } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';

// Pages
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import AggregateLevelsPage from './pages/AggregateLevelsPage';
import VideosPage from './pages/VideosPage';
import PortfolioPage from './pages/PortfolioPage';
import BlogPage from './pages/BlogPage';
import CommercialResidentialPage from './pages/CommercialResidentialPage';
import PolishedConcretePage from './pages/PolishedConcretePage';
import GrindAndSealPage from './pages/GrindAndSealPage';
import HonedConcretePage from './pages/HonedConcretePage';
import ConcreteGrindingPage from './pages/ConcreteGrindingPage';
import CommercialPage from './pages/CommercialPage';
import ResidentialPage from './pages/ResidentialPage';
import LandingPage from './pages/LandingPage';
import ThankYouPage from './pages/ThankYouPage';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Standard site layout (header + footer + floating WhatsApp) for all main pages.
function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Standalone landing page for ad campaigns - no global header/nav/footer */}
        <Route path="/quote" element={<LandingPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />

        {/* All other pages share the main site layout */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/polished-concrete" element={<PolishedConcretePage />} />
          <Route path="/services/grind-and-seal" element={<GrindAndSealPage />} />
          <Route path="/services/honed-concrete" element={<HonedConcretePage />} />
          <Route path="/services/concrete-grinding-floor-prep" element={<ConcreteGrindingPage />} />
          <Route path="/sectors/commercial" element={<CommercialPage />} />
          <Route path="/sectors/residential" element={<ResidentialPage />} />
          <Route path="/commercial-residential" element={<CommercialResidentialPage />} />
          <Route path="/aggregate-levels" element={<AggregateLevelsPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;
